import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 0,
  class: "icon-background",
  "data-test": "card-icon-thumbnail"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "status-badge-wrapper" }
const _hoisted_5 = {
  class: "title",
  "data-test": "status-badge"
}
const _hoisted_6 = {
  class: "title",
  "data-test": "card-title"
}
const _hoisted_7 = {
  class: "description",
  "data-test": "card-description"
}
const _hoisted_8 = {
  key: 0,
  class: "badge-wrapper"
}

import { computed } from "vue";
import {
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonIcon,
  IonBadge,
} from "@ionic/vue";
import { CardContent } from "@/store/models/card.models";
import { SanityAssessment } from "@/store/models/assessment.models";
import { parseImageUrl } from "@/helpers";
import { RouterLink } from "vue-router";
import CardPortraitSkeleton from "@/components/Skeletons/CardPortraitSkeleton/CardPortraitSkeleton.vue";
interface Props {
  typeBadge?: string;
  timeBadge?: number;
  statusBadge?: string;
  content: CardContent | SanityAssessment;
  url: string;
  isLoaded: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CardPortrait',
  props: {
    typeBadge: {},
    timeBadge: {},
    statusBadge: {},
    content: {},
    url: {},
    isLoaded: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const cardProps = computed(() => {
  return props.content as CardContent;
});

const featureImage = computed(() => {
  return props.content.featureImage
    ? parseImageUrl(props.content.featureImage, 300, 300)
    : require("@/assets/course-thumbnail-placeholder.png");
});

return (_ctx: any,_cache: any) => {
  return (!__props.isLoaded)
    ? (_openBlock(), _createBlock(CardPortraitSkeleton, {
        key: 0,
        "data-test": "card-portrait-skeleton"
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(RouterLink), {
          class: "router-link",
          to: { name: __props.url },
          "data-test": "router-link"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCard), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCardHeader), null, {
                  default: _withCtx(() => [
                    (cardProps.value.icon)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(_unref(IonIcon), {
                            icon: cardProps.value.icon,
                            "aria-hidden": "true",
                            "data-test": "card-icon"
                          }, null, 8, ["icon"])
                        ]))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: featureImage.value,
                          alt: "",
                          "data-test": "card-thumbnail"
                        }, null, 8, _hoisted_3))
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_4, [
                  (__props.statusBadge)
                    ? (_openBlock(), _createBlock(_unref(IonBadge), {
                        key: 0,
                        class: "status-badge complete-label",
                        "data-test": "status-badge"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createElementVNode("p", _hoisted_5, _toDisplayString(__props.statusBadge), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_unref(IonCardContent), null, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_6, _toDisplayString(props.content.title), 1),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(props.content.description), 1),
                    (__props.timeBadge || __props.typeBadge)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (__props.typeBadge)
                            ? (_openBlock(), _createBlock(_unref(IonBadge), {
                                key: 0,
                                class: "type-badge",
                                color: "secondary",
                                "data-test": "type-badge"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(__props.typeBadge), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (__props.timeBadge)
                            ? (_openBlock(), _createBlock(_unref(IonBadge), {
                                key: 1,
                                class: "time-badge",
                                "data-test": "time-badge"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(__props.timeBadge + " " + _ctx.$t("resource.readingTimeMins")), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]))
}
}

})